// extracted by mini-css-extract-plugin
export default {"page":"sbwRz","logs":"aasF0"};